import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { BaseComponentConfig, ComponentConfig, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { crmOptions } from '../../configoptions';
import { orderoptions } from './configoptions';

@Component({
  selector: 'pty-orders',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent extends BaseComponentConfig implements OnInit{
  partyId:string;

  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService,) { 
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    //console.log(configurationService.getProductStoreId())
    
    }
  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      if(params.get("partyId")){
        this.partyId = params.get("partyId");
        orderoptions.listForm.remoteFormData.parameters["partyId"]=this.partyId;
        this.componentConfig = new ComponentConfig(orderoptions);
      }
    })
  }


}
